"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRolePageApp = void 0;
const vue_1 = require("vue");
const provider_1 = require("../provider/provider");
const groupRoleBranchImpl_1 = require("../presenter/groupRoleBranchImpl");
const groupRoleBranchImpl_2 = require("../controller/groupRoleBranchImpl");
const groupRoleBranchImpl_3 = require("../subject/groupRoleBranchImpl");
const groupRoleBranchImpl_4 = require("../observer/groupRoleBranchImpl");
const branchImpl_1 = require("../subject/branchImpl");
const branchImpl_2 = require("../observer/branchImpl");
const branchImpl_3 = require("../controller/branchImpl");
const branch_1 = require("../webappApi/branch");
class GroupRolePageApp {
    appProvider;
    constructor(app, branchId, userId, groupId, isGroupOwner) {
        this.appProvider = app;
        this.initGroupRoleBranchModal(branchId, userId, groupId, isGroupOwner);
    }
    async initGroupRoleBranchModal(branchId, userId, groupId, isGroupOwner) {
        const webAppApi = new branch_1.BranchWebAppApiImpl();
        const branchSubject = new branchImpl_1.BranchSubjectImpl();
        const branchObs = new branchImpl_2.BranchObserverImpl(branchSubject);
        const branchController = new branchImpl_3.BranchControllerImpl(branchSubject, webAppApi);
        this.appProvider.provide(provider_1.branchControllerInjectKey, branchController);
        const groupRoleBranchSubject = new groupRoleBranchImpl_3.GroupRoleBranchSubjectImpl();
        const groupRoleBranchObs = new groupRoleBranchImpl_4.GroupRoleBranchObserverImpl(groupRoleBranchSubject);
        const groupRoleBranchController = new groupRoleBranchImpl_2.GroupRoleBranchControllerImpl(groupRoleBranchSubject);
        groupRoleBranchSubject.attach(groupRoleBranchObs);
        const groupRoleBranchViewModel = (0, vue_1.ref)({
            branchId: branchId,
            groupId: groupId,
            userId: userId,
            roleId: 0,
            isVisible: false,
            isLoading: false,
            filteredBranchIds: new Set(),
            paginatedBranchIds: [],
            selectedBranchIds: new Set(),
            allBranchesMap: new Map(),
            branchIdsToAdd: new Set(),
            branchIdsToRemove: new Set(),
            currentPage: 1,
            dataPerPage: 54,
            searchInput: "",
            isSearchBarOpen: false,
        });
        this.appProvider.provide(provider_1.groupRoleBranchViewModelInjectKey, (0, vue_1.readonly)(groupRoleBranchViewModel));
        const groupRoleBranchPresenter = new groupRoleBranchImpl_1.GroupRoleBranchPresenterImpl(groupRoleBranchViewModel.value, groupRoleBranchObs, branchObs, isGroupOwner);
        this.appProvider.provide(provider_1.groupRoleBranchInjectKey, {
            presenter: groupRoleBranchPresenter,
            controller: groupRoleBranchController,
        });
    }
}
exports.GroupRolePageApp = GroupRolePageApp;
